module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stream",
    class: _vm.streamClass
  }, [_c('div', {
    staticClass: "controls-bg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localInitialMode !== true),
      expression: "localInitialMode !== true"
    }],
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && _vm.showBitrate),
      expression: "!isLocalStream && showBitrate"
    }],
    staticStyle: {
      "text-align": "left",
      "color": "aqua"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bitrate) + "\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChatIcon),
      expression: "showChatIcon"
    }],
    attrs: {
      "title": _vm.$t('button_show_chat_title')
    },
    on: {
      "click": _vm.toggleChatPanelOpened
    }
  }, [_c('i', {
    staticClass: "icon-chat"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNewMessageIndicator),
      expression: "showNewMessageIndicator"
    }],
    staticClass: "icon-chat-new"
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "title": _vm.$t('button_mute_video_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleVideo($event)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && (_vm.videoEnabled && !_vm.sharingScreenOnly)),
      expression: "isLocalStream && (videoEnabled && !sharingScreenOnly)"
    }],
    staticClass: "icon-cam-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && (!_vm.videoEnabled || _vm.sharingScreenOnly)),
      expression: "isLocalStream && (!videoEnabled || sharingScreenOnly)"
    }],
    staticClass: "icon-cam-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && _vm.videoEnabled),
      expression: "!isLocalStream && videoEnabled"
    }],
    staticClass: "icon-cam-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && !_vm.videoEnabled),
      expression: "!isLocalStream && !videoEnabled"
    }],
    staticClass: "icon-cam-menu"
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "title": _vm.$t('button_mute_audio_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAudio($event)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && _vm.audioEnabled),
      expression: "!isLocalStream && audioEnabled"
    }],
    staticClass: "icon-audio-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLocalStream && !_vm.audioEnabled),
      expression: "!isLocalStream && !audioEnabled"
    }],
    staticClass: "icon-audio-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && _vm.audioEnabled),
      expression: "isLocalStream && audioEnabled"
    }],
    staticClass: "icon-micro-n-menu"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocalStream && !_vm.audioEnabled),
      expression: "isLocalStream && !audioEnabled"
    }],
    staticClass: "icon-micro-menu"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRemoteAudioMuted),
      expression: "isRemoteAudioMuted"
    }],
    staticClass: "remote-icon"
  }, [_c('i', {
    staticClass: "icon-remote-micro-menu"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "container": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('spinner', {
    attrs: {
      "isVisible": !_vm.isVideoReady || _vm.isSuspended
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuspended),
      expression: "isSuspended"
    }],
    staticClass: "connection-problem"
  }, [_vm._v("Connection problems...")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTallyActive),
      expression: "isTallyActive"
    }],
    staticClass: "tally"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoEnabled),
      expression: "!videoEnabled"
    }],
    staticClass: "video-muted"
  }, [_c('i', {
    staticClass: "tsc-cam-menu"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.audioEnabled && _vm.isLocalStream),
      expression: "!audioEnabled && isLocalStream"
    }],
    staticClass: "audio-muted"
  }, [_c('i', {
    staticClass: "tsc-micro-menu"
  })]), _vm._v(" "), _c('video', {
    class: [_vm.videoFlipped ? 'main-video-mirror' : 'main-video', {
      'share-mode-video': _vm.isScreenShare
    }],
    attrs: {
      "autoplay": "",
      "data-original": ""
    }
  }), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isScreenShare),
      expression: "isScreenShare"
    }],
    class: {
      'share-mode-screen': _vm.isScreenShare
    },
    attrs: {
      "autoplay": "",
      "data-screen": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zoom"
  }, [_c('div', {
    staticClass: "move-center"
  }, [_c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "icon-zoom"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-grid"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3118d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stream.vue
// module id = 366
// module chunks = 1